import axios from '@/axios'
import { getMessageFromError } from '@/utils/functions'

export default {
  // get location type
  getLocationTypes: async ({ commit }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.get('location/types')

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'locationTypes',
        data: res.data.data.map(locType => ({
          ...locType,
          value: locType.Id,
          label: locType.Name
        }))
      })

      return {
        data: res.data.data
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get location by id
  getLocationById: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })

    try {
      const res = await axios.get(`/location/${id}`)

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'location',
        data: res.data.location
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // get locations
  fetchLocations: async ({ commit }, payload) => {
    try {
      const res = await axios.get('location', { params: { ...payload } })

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      commit('SET_STATE', {
        action: 'total',
        data: res.data.totalCount
      })

      commit('SET_STATE', {
        action: 'FilteredCount',
        data: res.data.FilteredCount
      })

      commit('SET_STATE', {
        action: 'locations',
        data: res.data.data
      })

      return {
        data: res.data.data
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  //get all location names
  getLocationOptions: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      payload = {
        page: 1,
        limit: 0
      }
      const res = await axios.get('location', { params: { ...payload } })
      return {
        data: res.data.data.map(location => ({
          value: location.id,
          label: `${location.name}`
        })),
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // add new location
  addNewLocaton: async ({ commit }, payload) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.post('location', payload)

      commit('SET_STATE', {
        action: 'loading',
        data: false
      })

      return {
        data: res.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // update location
  updateLocationById: async ({ commit }, { id, data }) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.put(`location/${id}`, data)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  },

  // delete locations
  deleteLocation: async ({ commit }, id) => {
    commit('SET_STATE', {
      action: 'loading',
      data: true
    })
    try {
      const res = await axios.delete(`/location/${id}`)
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      return {
        data: res.data.data,
        message: res.data.message
      }
    } catch (err) {
      commit('SET_STATE', {
        action: 'loading',
        data: false
      })
      const { message } = getMessageFromError(err)
      return Promise.reject({
        message
      })
    }
  }
}
